import { render, staticRenderFns } from "./ProductMappingOld.vue?vue&type=template&id=97976a90&scoped=true"
import script from "./ProductMappingOld.vue?vue&type=script&lang=js"
export * from "./ProductMappingOld.vue?vue&type=script&lang=js"
import style0 from "./ProductMappingOld.vue?vue&type=style&index=0&id=97976a90&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97976a90",
  null
  
)

export default component.exports